export default function execute_on(id, callback) {
    // find element by 'page- + id' id, it is recommended to use the id on the body
    const container = document.getElementById('page-' + id);
    // break execution if page is not detected
    if(null !== container) {
        $(function () {
            callback($(container));
        })
    }
}
